import {Column} from "primereact/column"
import {DataTable} from "primereact/datatable"
import {useRef} from "react"
import useSWR from "swr"

import {fetcherGet} from "../utilities/general"
import {useStableNavigate} from "../utilities/StableNavigateContext"

export function OrienteeOrientations({orientee_id, user_id}) {
    const {data: orientations, isLoading} = useSWR(`/get-orientations?user-id=${user_id}`, fetcherGet, {
        fallbackData: [],
    })
    const tableRef = useRef(undefined)
    const navigate = useStableNavigate()

    return (
        <>
            {!isLoading && orientations.length > 1 && (
                <div className="container-fluid d-flex flex-column">
                    <div className="card p-8 mt-6">
                        <h2>Other Orientations</h2>
                        <DataTable
                            ref={tableRef}
                            value={orientations.filter((o) => o.id !== orientee_id)}
                            tableClassName="table gy-3 gs-5 rounded w-100 mt-3 align-middle"
                            sortField="unit_name"
                            sortOrder={1}
                            onMouseDownCapture={(e) => {
                                e.stopPropagation()
                            }}
                        >
                            <Column
                                field="unit_name"
                                header="Location"
                                headerClassName="text-light text-uppercase bg-gray-700 fs-7 fw-bold p-sortable-column"
                                sortable
                                exportable={true}
                                exportField="unit_name"
                            />
                            <Column
                                field="hire_date"
                                header="Hire Date"
                                headerClassName="text-light text-uppercase bg-gray-700 fs-7 fw-bold p-sortable-column"
                                sortable
                                exportable={true}
                                exportField="hire_date"
                            />
                            <Column
                                field="orientation_status"
                                header="Orientation Status"
                                headerClassName="text-light text-uppercase bg-gray-700 fs-7 fw-bold p-sortable-column"
                                sortable
                                exportable={true}
                                exportField="orientation_status"
                            />
                            <Column
                                field="orientation_end_date"
                                header="Orientation End Date"
                                headerClassName="text-light text-uppercase bg-gray-700 fs-7 fw-bold p-sortable-column"
                                sortable
                                exportable={true}
                                exportField="orientation_end_date"
                            />
                            <Column
                                header="Actions"
                                headerClassName="text-light text-uppercase bg-gray-700 fs-7 fw-bold"
                                exportable={false}
                                body={(row) => {
                                    return (
                                        <>
                                            <button
                                                className="btn btn-primary hover-elevate-down position-relative me-2"
                                                onClick={() => {
                                                    navigate(`/orientees/edit/${row.id}?tab=details`)
                                                }}
                                            >
                                                Details
                                            </button>
                                            <button
                                                className="btn btn-primary hover-elevate-down position-relative me-2"
                                                onClick={() => {
                                                    navigate(`/orientees/edit/${row.id}?tab=osrs`)
                                                }}
                                            >
                                                OSRs {row.osr_count ? ` (${row.osr_count})` : ""}
                                            </button>
                                            <button
                                                className="btn btn-primary hover-elevate-down position-relative"
                                                onClick={() => {
                                                    navigate(`/orientees/edit/${row.id}?tab=nhsrs`)
                                                }}
                                            >
                                                NHSRs {row.nhsr_count ? ` (${row.nhsr_count})` : ""}
                                            </button>
                                        </>
                                    )
                                }}
                            />
                        </DataTable>
                    </div>
                </div>
            )}
        </>
    )
}
